module.exports = __webpack_public_path__ + "img/790-739474.png";